export enum InheritedValuesType {
  VARIABLE_IDS_AND_NAMES = 'VARIABLE_IDS_AND_NAMES',
  VARIABLE_VALUES = 'VARIABLE_VALUES'
}

export type MergedInheritedValue<T = any> = {
  value: T
  owner?: string
  inherited?: boolean
}
export type MergedInheritedValues<T = any> = {
  [key: string]: MergedInheritedValue<T>
}

export interface InheritedValuesInterface {
  id: number
  type: InheritedValuesType
  owner: string
  data: { [key: string]: any }
}
